import { makeAuthenticatedRequest } from './api';

// makeAuthenticatedRequest already unwraps `responseData.data`, so every call here resolves to the
// preference payload itself. Never re-read `.data`.

/**
 * The signed-in admin's UI preferences.
 * `dashboardQuickLinks` is null when they have never customised them; an empty array means they
 * removed every one.
 */
export const getUserPreferences = async () =>
  makeAuthenticatedRequest('/user-preferences/get', { method: 'POST', body: {} });

/**
 * Replaces the signed-in admin's quick links. The whole ordered list is sent each time.
 * @param {string[]} dashboardQuickLinks - in-app paths.
 */
export const saveQuickLinks = async (dashboardQuickLinks) =>
  makeAuthenticatedRequest('/user-preferences/quick-links', { method: 'POST', body: { dashboardQuickLinks } });

/**
 * Sets which dashboard the signed-in admin sees (ticket 77).
 * @param {'new'|'old'|null} dashboardVersion - null goes back to following the org default.
 */
export const saveDashboardVersion = async (dashboardVersion) =>
  makeAuthenticatedRequest('/user-preferences/dashboard-version', { method: 'POST', body: { dashboardVersion } });

/**
 * Opts the signed-in admin in or out of broadcast admin emails (ticket 101).
 * Password resets and anything addressed to them personally are sent regardless.
 * @param {boolean} emailNotificationsEnabled
 */
export const saveEmailNotifications = async (emailNotificationsEnabled) =>
  makeAuthenticatedRequest('/user-preferences/email-notifications', { method: 'POST', body: { emailNotificationsEnabled } });
